import { render } from "./SyncedImage.vue?vue&type=template&id=75ebdddc"
import script from "./SyncedImage.vue?vue&type=script&lang=js"
export * from "./SyncedImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__